//
// Module for the Benefit Claims - In Progress partial view
//
rs.module("participant/benefit/claims/inprogress",

    ["common/select-helper"],

    function (selectHelper) {

        function initialize(jsSelectors) {

            // initialize js selectors
            var inProgressForm = $.js(jsSelectors.inProgressForm, { required: false });

            var paymentAddressType = inProgressForm.js(jsSelectors.paymentAddressType, { required: false });
            var paymentContactType = inProgressForm.js(jsSelectors.paymentContactType, { required: false });
            var _1099AddressType = inProgressForm.js(jsSelectors._1099AddressType, { required: false });
            var _1099ContactType = inProgressForm.js(jsSelectors._1099ContactType, { required: false });

            if (inProgressForm) {

                // initialize select helpers
                var paymentAddressTypeSelectHelper = selectHelper.getHelper(paymentAddressType);
                var paymentContactTypeSelectHelper = selectHelper.getHelper(paymentContactType);
                var _1099AddressTypeSelectHelper = selectHelper.getHelper(_1099AddressType);
                var _1099ContactTypeSelectHelper = selectHelper.getHelper(_1099ContactType);

                // payment address type change handler - clear payment contact type
                paymentAddressType.change(function () {
                    paymentContactTypeSelectHelper.setValue(null);
                });

                // payment contact type change handler - clear payment address type
                paymentContactType.change(function () {
                    paymentAddressTypeSelectHelper.setValue(null);
                });

                // 1099 address type change handler - clear 1099 contact type
                _1099AddressType.change(function () {
                    _1099ContactTypeSelectHelper.setValue(null);
                });

                // 1099 contact type change handler - clear 1099 address type
                _1099ContactType.change(function () {
                    _1099AddressTypeSelectHelper.setValue(null);
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);